import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import * as providers from './providers';
import * as models    from '../models/models';

@Injectable()
export class Guard implements CanActivate {

    constructor(private router: Router,
                private db: providers.StamplingDB) { }

    canActivate(): boolean {
        var logged: models.FirebaseUser = this.db.getLoggedUser();
        if (logged!=null) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page
        return false;
    }
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/providers/Guard.ts